var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationCity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24.505,
    viewBox: "0 0 23 24.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location_city",
    d: "M18.833,13.75V6.583L15.25,3,11.667,6.583V8.972H4.5V25.694H26V13.75ZM9.278,23.306H6.889V20.917H9.278Zm0-4.778H6.889V16.139H9.278Zm0-4.778H6.889V11.361H9.278Zm7.167,9.556H14.056V20.917h2.389Zm0-4.778H14.056V16.139h2.389Zm0-4.778H14.056V11.361h2.389Zm0-4.778H14.056V6.583h2.389Zm7.167,14.333H21.222V20.917h2.389Zm0-4.778H21.222V16.139h2.389Z",
    transform: "translate(-3.75 -1.939)",
    fill: "none",
    stroke: "#7d7d7d",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCity);
export default __webpack_public_path__ + "static/media/location_city.febab668348a050cea434d250815b4de.svg";
export { ForwardRef as ReactComponent };